module.exports = __vendor;


//////////////////
// WEBPACK FOOTER
// external "__vendor"
// module id = 9
// module chunks = 0